import { connect as formikConnect } from 'formik';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose, setDisplayName, setPropTypes } from 'recompact';

import { UNIFIED } from 'src/app/analytics/analyticsEvents';
import { getMedicationFormByIndex, segmentTrack, updateMedicationForm } from 'src/app/state/actions';
import type { Dispatch } from 'src/app/state/store';

import { Renderer } from '.';

const mapDispatchToProps = (dispatch: Dispatch) => ({
  dispatchFieldFocused: ({ target }) => {
    const { name } = target;
    const payload = {
      pagepath: window.location.pathname,
      fieldname: name,
    };
    return dispatch(segmentTrack(UNIFIED.fieldFocused, payload));
  },
  dispatchGetMedicationFormByIndex: doctorFormIndex => dispatch(getMedicationFormByIndex(doctorFormIndex)),
  dispatchUpdateMedicationForm: (medicationFormIndex, newMedicationForm) =>
    dispatch(updateMedicationForm(medicationFormIndex, newMedicationForm)),
});

const ApiAutoComplete = compose(
  connect(null, mapDispatchToProps),
  setDisplayName('ApiAutoComplete'),
  setPropTypes({
    /**
     * Represents the method that should be called with the inputValue
     * to retrieve results from an asynchronous resource.  It should
     * return an array of results.
     *
     * Ex:
     * async function apiCall(searchQuery) {
     *    const response = await callRemoteApi(searchQuery);
     *    return response?.data ?? [];
     * }
     */
    apiCall: PropTypes.func.isRequired,

    /**
     * Represents the set of props that will be passed to the TextInput
     * Component.  See components/Form/TextInput/index.js for propTypes
     *
     * Ex:
     *  const textInputProps = { name: 'first_name', label: 'First name: ' };
     */
    textInputProps: PropTypes.object.isRequired,

    /**
     * Used to convert a selected item into a string which is then
     * used to set the input value.
     * https://github.com/paypal/downshift#itemtostring
     *
     * Ex:
     * function selectedItemToString(item) {
     *  return item?.value ?? '';
     * }
     */
    selectedItemToString: PropTypes.func.isRequired,

    /**
     * Used to convert list of items into autocomplete option texts.
     */
    optionItemToString: PropTypes.func.isRequired,

    /**
     * This function gets called when an item is selected.
     */
    setRelatedFields: PropTypes.func,
    /**
     * This is text that will show if no items return that match the search
     */
    noMatchingItemsText: PropTypes.string,
  }),
  formikConnect
)(Renderer);

export { ApiAutoComplete };
